/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Emptylogout1Inputs */

const en_welcome_terms_emptylogout1 = /** @type {(inputs: Welcome_Terms_Emptylogout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Welcome_Terms_Emptylogout1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_emptylogout1 = /** @type {((inputs?: Welcome_Terms_Emptylogout1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Emptylogout1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_emptylogout1(inputs)
});
export { welcome_terms_emptylogout1 as "welcome_terms_emptyLogout" }